(function () {
  angular.module("akitabox.core.auth.lockedOut", [
    "ui.router",
    "akitabox.core.router",
    "akitabox.core.services.auth",
  ]);
})();
